import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Report from "../../common/Report";
import { FieldsProvider } from "../../../context/FieldsContext";
// import AICVDPdfDetails from "../../../components/pdfReports/AICVDPdfReport";
import {
  getImagesFromDB,
  fetchAndStoreImages,
} from "../../../utils/imageUtils";
import CKDLandingPage from "../../All_Projects_Landing_Pages/CKDLandingPage";
import CKDDetailsPage from "../../All_Project_Components/CKDComponent";
import CKDPdfReport from "../../pdfReports/CKDReport";

const CKDRoutes = (props) => {
  const AICKD_LANDING_URL =
    "https://clinical-server-apis.azurewebsites.net/fields/ckd";
  const AICKD_REPORT_URL = "https://clinical-server-apis.azurewebsites.net/ckd";

  const [formDetails, setFormDetails] = useState({});
  const [PdfInfo, setPDFDetails] = useState({});
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState([]);
  const [units, setUnits] = useState({});

  const app = "aickd";

  const color = "#034258ff";
  const secondaryColor = "#004b66";
  const button_hover_color = "#7aaabbff";
  const surface_color = "rgb(235 246 250)";
  const surface_hover_color = "#e8e0e8";
  const surface_highlight_color = "#dcdaf5";
  const gender_highlight_color = "#675496";
  const button_color = "rgb(123, 104, 171)";
  const surface_highlight_dark_color = "rgb(103, 84, 150)";

  const form_details = (props) => {
    const details = {
      id: props.patient_id,
      name: props.name,
      age: parseInt(props.age, 10) || 0,
      gender:
        props.gender?.toLowerCase() === "male"
          ? "Male"
          : props.gender?.toLowerCase() === "female"
            ? "Female"
            : "Male",
      location: props.location,
      email: props.email,
      phone: props.phone,

      height: props.height,
      weight: props.weight,
      bmi: props.BMI,
      diabetes: props.diabetes !== "no" ? "Yes" : "No",
      diabetes_params: {
        diabetes_selected_value: props.diabetes,
        diabetes_condition: props.diabetes_test_date,
        diabetes_test_date: props.diabetes_test_date,
        diabetes_test_value: props.diabetes_test_value,
      },
      diabetes_test_date: props.diabetes_test_date,
      diabetes_test_value: props.diabetes_test_value,
      hypertension: props.hypertension?.toLowerCase() === "yes" ? "Yes" : "No",
      hypertension_params: {
        "Two hypertension diagnoses (≥14 days apart)":
          props.hypertension_list?.includes(
            "Two hypertension diagnoses (≥14 days apart)"
          )
            ? "yes"
            : "no",
        "A hypertension diagnosis and a hypertension medication prescription":
          props.hypertension_list?.includes(
            "A hypertension diagnosis and a hypertension medication prescription"
          )
            ? (props.hypertension_second_list || props.hypertensionSecondOptionList)
            : "no",
        "A hypertension diagnosis": props.hypertension_list?.includes(
          "A hypertension diagnosis"
        )
          ? "yes"
          : "no",
      },
      dyslipidaemia: props.dyslipidemia?.toLowerCase() === "yes" ? "Yes" : "No",
      dyslipidemia_params: {
        "An elevated lipids diagnosis": props.dyslipidemia_list?.includes(
          "An elevated lipids diagnosis"
        )
          ? "yes"
          : "No",
        "A prescription for elevated lipids medication":
          props.dyslipidemia_list?.includes(
            "A prescription for elevated lipids medication"
          )
            ? props.dyslipidemia_second_list
            : "No",
        "Lab results": props.dyslipidemia_list?.includes("Lab results")
          ? {
            "Triglyceride level": props.dyslipidemia_third_list?.includes(
              "Triglyceride level"
            )
              ? props.dyslipidemia_third_list
              : "No",
            "HDL level": props.dyslipidemia_third_list?.includes("HDL level")
              ? props.dyslipidemia_third_list
              : "No",
            "Non-HDL value mg/dL": props.dyslipidemia_third_list?.includes(
              "Non-HDL value mg/dL"
            )
              ? props.dyslipidemia_third_list
              : "No",
          }
          : "No",
      },

      cvd: props.cvd?.toLowerCase() === "yes" ? "Yes" : "No",
      urological_problems:
        props.urological_problems?.toLowerCase() === "yes" ? "Yes" : "No",
      systemic_illness:
        props.systemic_illness?.toLowerCase() === "yes" ? "Yes" : "No",
      anemia: props.anemia?.toLowerCase() === "yes" ? "Yes" : "No",
      pulmonary: props.pulmonary?.toLowerCase() === "yes" ? "Yes" : "No",
      hyperkalemia: props.hyperkalemia?.toLowerCase() === "yes" ? "Yes" : "No",
      smoking: props.smoking?.toLowerCase() === "yes" ? "Yes" : "No",
      tobacco: props.tobacco?.toLowerCase() === "yes" ? "Yes" : "No",

      familyHistorycvd:
        props.familyHistorycvd?.toLowerCase() === "yes" ? "Yes" : "No",
      familyHistoryckd:
        props.familyHistoryckd?.toLowerCase() === "yes" ? "Yes" : "No",
      familyHistoryDiabetes:
        props.familyHistoryDiabetes?.toLowerCase() === "yes" ||
          props.familyHistoryDiabetes?.toLowerCase()?.includes("controlled")
          ? "Yes"
          : "No",
      familyHistoryHypertension:
        props.familyHistoryHypertension?.toLowerCase() === "yes" ? "Yes" : "No",

      albumin_serum: props.albumin_serum !== undefined ? parseFloat(props.albumin_serum) : undefined,
      calcium_serum: props.calcium_serum !== undefined ? parseFloat(props.calcium_serum) : undefined,
      hemoglobin: props.hemoglobin !== undefined ? parseFloat(props.hemoglobin) : undefined,
      urea: props.urea !== undefined ? parseFloat(props.urea) : undefined,
      potassium: props.potassium !== undefined ? parseFloat(props.potassium) : undefined,
      sodium: props.sodium !== undefined ? parseFloat(props.sodium) : undefined,
      uric_acid: props.uric_acid !== undefined ? parseFloat(props.uric_acid) : undefined,
      creatinine_serum: props.creatinine_serum !== undefined ? parseFloat(props.creatinine_serum) : undefined,
      platelet_count: props.platelet_count !== undefined ? parseInt(props.platelet_count, 10) : undefined,
      magnesium: props.magnesium !== undefined ? parseFloat(props.magnesium) : undefined,
      hba1c: props.hba1c !== undefined ? parseFloat(props.hba1c) : undefined,
      ggt: props.ggt !== undefined ? parseFloat(props.ggt) : undefined,
      ast: props.ast !== undefined ? parseFloat(props.ast) : undefined,
      phosphate: props.phosphate !== undefined ? parseFloat(props.phosphate) : undefined,
      chloride: props.chloride !== undefined ? parseFloat(props.chloride) : undefined,
      proteinuria: props.proteinuria !== undefined ? parseFloat(props.proteinuria) : undefined,
      urine_albumin: props.urine_albumin !== undefined ? parseFloat(props.urine_albumin) : undefined,
      urine_protein: props.urine_protein !== undefined ? parseFloat(props.urine_protein) : undefined,
      bun: props.bun !== undefined ? parseFloat(props.bun) : undefined,
      urine_creatinine: props.urine_creatinine !== undefined ? parseFloat(props.urine_creatinine) : undefined,
      egfr: props.egfr !== undefined ? parseFloat(props.egfr) : undefined,
      diff_days: 365,
    };
    const pdf_details = {
      basic_info: {
        UHID: props.patient_id,
        Name: props.name,
        Age: props.age,
        Gender: props.gender,
        Location: props.location,
        Mobile: props.phone,
      },
      "Physical Attributes": {
        Height: props.height,
        Weight: props.weight,
        BMI: props.BMI,
      },

      "Medical History": {
        "Diabetes Mellitus": props.diabetes,
        Hypertension: props.hypertension,
        Dyslipidaemia: props.dyslipidemia,
        CVD: props.cvd,
        "Urological Problems": props.urological_problems,
        "Systemic Illness": props.systemic_illness,
        Anemia: props.anemia,
        Pulmonary: props.pulmonary,
        Hyperkalemia: props.hyperkalemia,
        Smoking: props.smoking,
        Tobacco: props.tobacco,
      },

      "Family History": {
        "Family History CVD": props.familyHistorycvd,
        "Family History CKD": props.familyHistoryckd,
        "Family History Diabetes": props.familyHistoryDiabetes,
        "Family History Hypertension": props.familyHistoryHypertension,
      },

      "Lab History": {
        "Albumin Serum": props.albumin_serum,
        "Calcium Serum": props.calcium_serum,
        EGFR: props.egfr,
        "Diff Days": 365,
        Hemoglobin: props.hemoglobin,
        Urea: props.urea,
        Potassium: props.potassium,
        sodium: props.sodium,
        "Uric Acid": props.uric_acid,
        "Creatinine Serum": props.creatinine_serum,
        "Platelet Count": props.platelet_count,
        Magnesium: props.magnesium,
        Hba1c: props.hba1c,
        Ggt: props.ggt,
        Ast: props.ast,
        Phosphate: props.phosphate,
        Chloride: props.chloride,
        Proteinuria: props.proteinuria,
        "Urine Albumin": props.urine_albumin,
        "Urine Protein": props.urine_protein,
        Bun: props.bun,
        "Urine Creatinine": props.urine_creatinine,
      },
    };

    const units = {
      Height: "cm",
      Weight: "kg",
      BMI: "kg/m2",

      "Albumin Serum": "gm/dL",
      "Calcium Serum": "mg/dL",
      Hemoglobin: "g/dL",
      Urea: "mg/dL",
      Potassium: "mmol/L",
      sodium: "mmol/L",
      "Uric Acid": "mg/dL",
      "Creatinine Serum": "mg/dL",
      "Platelet Count": "10^3/mm3",
      Magnesium: "mg/dL",
      Hba1c: "%",
      Ggt: "U/L",
      Ast: "U/L",
      Phosphate: "mg/dL",
      Chloride: "mmol/L",
      Proteinuria: "mg/24h",
      "Urine Albumin": "mg/mmol",
      "Urine Protein": "mg/mmol",
      Bun: "mg/dL",
      "Urine Creatinine": "mg/dL",
    };

    setUnits(units);
    setFormDetails(details);
    setPDFDetails(pdf_details);
  };

  useEffect(() => {
    const loadImages = async () => {
      try {
        const storedImages = await getImagesFromDB(app);
        if (storedImages.length > 0) {
          setImages(storedImages);
        } else {
          const urls = [
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/iStock-644984072_vhiiap_c_scale%252Cw_1400.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicvd-app-page-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicvd-app-page-2.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/intepretation-img-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_certificate_MD%20763515.png",
          ];
          await fetchAndStoreImages(app, urls, setImages);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };
    loadImages();
  }, []);

  return (
    <FieldsProvider>
      <Routes>
        <Route
          path="/"
          element={
            <CKDLandingPage
              LANDING_URL={AICKD_LANDING_URL}
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              images={images}
              loading={loading}
            />
          }
        />
        <Route
          path="patient-details"
          element={
            <CKDDetailsPage
              app={app}
              LANDING_URL={AICKD_LANDING_URL}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              gender_highlight_color={gender_highlight_color}
              surface_highlight_dark_color={surface_highlight_dark_color}
              button_color={button_color}
              form_details={form_details}
            />
          }
        />
        <Route
          path="report"
          element={
            <Report
              app={app}
              formDetails={formDetails}
              REPORT_URL={AICKD_REPORT_URL}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
            />
          }
        />
        <Route
          app={app}
          path="pdfreport"
          element={
            <CKDPdfReport
              formDetails={formDetails}
              PdfInfo={PdfInfo}
              color={color}
              units={units}
            />
          }
        />
      </Routes>
    </FieldsProvider>
  );
};

export default CKDRoutes;
